import clsx from 'clsx';

const variants = {
  neutral: 'bg-slate-100 text-slate-700',
  brand: 'bg-brand-50 text-brand-700',
  info: 'bg-accent-50 text-accent-800',
  success: 'bg-success-50 text-success-700',
  warning: 'bg-warning-50 text-warning-700',
  danger: 'bg-danger-50 text-danger-700',
};

export default function Badge({ children, className, color, variant }) {
  // `variant` is the preferred API. `color` (raw utility string) and a `className`
  // carrying its own `bg-*` are both still honoured, and neither gets the default
  // tone painted underneath it any more.
  let tone;
  if (variant) tone = variants[variant] || variants.neutral;
  else if (color) tone = color;
  else if (!/(?:^|\s)bg-/.test(className || '')) tone = variants.neutral;

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold tracking-wide',
        tone,
        // Consumer className is merged last so it wins on class-attribute order.
        className
      )}
    >
      {children}
    </span>
  );
}
